<template>
    <div>
      <br />
        <v-row v-bind:class="marginesy">
            <v-col cols="1"></v-col>
            <v-col cols="10">
                <p class="text-h4 text-center">DZIĘKUJEMY ZA ZAKUP!</p>
                <br />
                <p class="text-center">Na wskazany adres e-mail przesłane zostało potwierdzenie zamówienia. Po zaksięgowaniu płatności, zamówienie zostanie przekazane do realizacji</p>
                <br />
                <v-card
                class="mx-auto"
                max-width="400"
                variant="outlined"
                >
                    <v-card-item>
                        <div>
                            <div class="text-overline mb-1">
                                Dane do przelewu:
                            </div>
                            <div class="text-h6 my-1">
                                Tytuł: Zamówienie nr {{ order_num }}
                            </div>
                            <div class="text-subtitle-1">
                                84 1050 1520 1000 0090 6749 4519
                            </div>
                            <div class="text-caption">Alpakowy Raj Paweł Milde</div>
                            <div class="text-caption">ul. Obornicka 250/2 60-693 Poznań</div>
                        </div>
                    </v-card-item>
                </v-card>
                <br />
                <p class="text-h5 text-center">Zapraszamy ponownie!</p>
            </v-col>
            <v-col cols="1"></v-col>
        </v-row>
        <v-row justify="center" class="mb-3">
          <v-col cols="3"></v-col>
          <v-col cols="6">
            <v-img
            src='../assets/thankyoupic.jpg'
            height="350"
            ></v-img>
          </v-col>
          <v-col cols="3"></v-col>
        </v-row>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    data () {
      return {
        mobile: false,
        marginesy: '',
        order_num: '',
      }
    },
    computed: {
      ...mapGetters([
        'getOrderNum',
      ]),
    },
    created() {
      this.mobile = this.$vuetify.display.mobile
      if(this.$vuetify.display.mobile == false){
        this.marginesy = "mt-16 mx-16 justify-center"
      }
    },
    mounted() {
      if(this.getOrderNum.length < 1){
        this.$router.push('/podsumowanie')
      } else {
        this.order_num = this.getOrderNum[0].num;
      }
    },
  } 
</script>